import React from "react";

import {
  useNavigate,
} from "react-router-dom";

import {

  FaArrowRight,

  FaStar,

  FaShieldAlt,

  FaTruck,

} from "react-icons/fa";

import "../styles/HeroSection.css";

const HeroSection = () => {

  const navigate =
    useNavigate();

  return (

    <section className="sacHeroSection">

      {/* =====================================================
      VIDEO BACKGROUND
      ===================================================== */}

      <video
        className="sacHeroVideo"

        autoPlay

        muted

        loop

        playsInline

        preload="auto"
      >

        <source
          src="/videos/mtb.mp4"
          type="video/mp4"
        />

      </video>

      {/* =====================================================
      OVERLAYS
      ===================================================== */}

      <div className="sacHeroOverlay"></div>

      <div className="sacHeroGradient"></div>

      {/* =====================================================
      GLOW EFFECT
      ===================================================== */}

      <div className="sacHeroGlow"></div>

      {/* =====================================================
      CONTENT
      ===================================================== */}

      <div className="sacHeroContent">

        {/* BADGE */}

        <div className="sacHeroBadge">

          🔥 Best Selling Collection

        </div>

        {/* TITLE */}

        <h1 className="sacHeroTitle">

          RIDE

          <br />

          WITHOUT

          <br />

          <span>

            LIMITS

          </span>

        </h1>

        {/* DESCRIPTION */}

        <p className="sacHeroDescription">

          Premium bicycles &
          luxury ride-on experiences
          crafted for adventure,
          performance and unforgettable rides.

        </p>

        {/* =====================================================
        CTA BUTTONS
        ===================================================== */}

        <div className="sacHeroButtons">

          <button
            className="sacPrimaryBtn"

            onClick={() =>
              navigate("/products")
            }
          >

            Explore Bicycles

            <FaArrowRight />

          </button>

          <button
            className="sacSecondaryBtn"

            onClick={() =>
              navigate("/toys")
            }
          >

            Ride-On Toys

          </button>

        </div>

        {/* =====================================================
        STATS
        ===================================================== */}

        <div className="sacHeroStats">

          <div className="sacStatItem">

            <h3>

              10K+

            </h3>

            <p>

              Happy Riders

            </p>

          </div>

          <div className="sacStatItem">

            <h3>

              50+

            </h3>

            <p>

              Cities Served

            </p>

          </div>

          <div className="sacStatItem">

            <h3>

              4.8★

            </h3>

            <p>

              Customer Rating

            </p>

          </div>

        </div>

        {/* =====================================================
        TRUST
        ===================================================== */}

        <div className="sacHeroTrusts">

          <div className="sacTrustItem">

            <FaStar />

            <span>

              Trusted by 10,000+ Customers

            </span>

          </div>

          <div className="sacTrustItem">

            <FaTruck />

            <span>

              Free Delivery Across India

            </span>

          </div>

          <div className="sacTrustItem">

            <FaShieldAlt />

            <span>

              100% Secure Payments

            </span>

          </div>

        </div>

      </div>

      {/* =====================================================
      SCROLL INDICATOR
      ===================================================== */}

      <div className="sacScrollIndicator">

        <span></span>

      </div>

    </section>
  );
};

export default HeroSection;